var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Const } from './provider/lib/const.cls';
import { mapActions } from 'vuex';
import { registerSteps } from './lib/registerSteps.cls';
import * as registerStepsStoreExtensions from './provider/';
var state = __assign({}, registerStepsStoreExtensions.stateExt);
var actions = __assign({}, registerStepsStoreExtensions.actionsExt);
var mutations = __assign({}, registerStepsStoreExtensions.mutationsExt);
var getters = __assign({}, registerStepsStoreExtensions.gettersExt);
// new store module definition
var registerStepsStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module
export var registerStepsMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[registerSteps.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(registerSteps.STORE_MODULE_NAME, registerStepsStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({}, mapActions({
        //===================common-steps===========================
        _runStep1: Const.RUN_STEP1,
        _runStep2: Const.RUN_STEP2,
        _runStep3: Const.RUN_STEP3,
        _runGetStepInfo: Const.RUN_GET_STEP_INFO,
        _runDelDoc: Const.RUN_DEL_DOC,
        //===================individual-steps=======================
        _runStep4: Const.RUN_STEP4,
        _runStep5: Const.RUN_STEP5,
        _runStep6: Const.RUN_STEP6,
        _runGenerateOtp: Const.RUN_GENERATE_OTP,
        //==================corporate-steps==========================
        _runCorStep4: Const.RUN_COR_STEP4,
        _runCorStep5: Const.RUN_COR_STEP5,
        _runCorStep6: Const.RUN_COR_STEP6,
        _runCorStep7: Const.RUN_COR_STEP7,
        _runGetImageOtp: Const.RUN_GET_IMAGE_OTP,
        _runGetQuestion: Const.RUN_GET_QUESTION,
        _runQuestion: Const.RUN_QUESTION,
        _runFinancialQuestion: Const.RUN_FINANCIAL_QUESTION,
        _runFinancialDocs: Const.RUN_FINANCIAL_DOCS,
    })), { computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        } }),
    computed: {
        step2: function () { return this.computedCommonFunc(Const.GET_STEP2); },
        step3: function () { return this.computedCommonFunc(Const.GET_STEP3); },
        question: function () { return this.computedCommonFunc(Const.GET_QUESTION); },
    }
};
export default registerStepsMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/registerSteps/index.ts
// module id = null
// module chunks = 